import { useEffect, useRef, ReactNode } from "react";
import { trackSectionView } from "@/hooks/usePageTracking";

export function SectionTracker({ id, children }: { id: string; children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  const tracked = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting && !tracked.current) {
          tracked.current = true;
          trackSectionView(id);
        }
      },
      { threshold: 0.2 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [id]);

  return <div ref={ref}>{children}</div>;
}
